<template>
    <v-layout class="map-container" fill-height v-resize="resizeMap">       
        <map-control :uiid="map_uiid" />
        <fleet-map :uiid="map_uiid" ref="map"  >
          <slot></slot>
        </fleet-map>                   
    </v-layout> 
</template>
<script setup lang="ts">
  import { ref, computed, watch, onMounted } from 'vue'
  import FleetMap from '@/components/map/FleetMap.vue'
  import MapControl from '@/components/map/MapControl.vue'  
  import store from '@/store'
  import { buildFleetUIStateId } from '@/models/ui/FleetUiState'
  
  const props = defineProps<{
    uiid: string
  }>()

  
  const map = ref()

  const fleet = computed(() => store.myGetters.modifiedAdmAdminFleet)
  const map_uiid = computed(() => buildFleetUIStateId(fleet.value.FLE_ID!, "map"))

  const leftPanelWidth = computed(() => store.myGetters.currentDetailFleet.leftPanelWidth)

  // Watch for leftPanelWidth changes
  watch(leftPanelWidth, (newValue: string) => {
    if (map.value) {
      map.value.updateSize()
    }
  })

  // Watch for map_uiid changes
  watch(map_uiid, (newValue: string) => {
    store.myActions.UI_ENSURE_FLEETMAP_STATE(newValue)
  })

  onMounted(() => {
    setTimeout(() => resizeMap(), 2000)
  })
  
  function resizeMap() {
    // console.log("resizeMap")
    if (map.value) {
      map.value.updateSize()
    }
  }
  
  // Created lifecycle - ensure map state
  store.myActions.UI_ENSURE_FLEETMAP_STATE(map_uiid.value)

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  
</style>
